var React = require('react');

function ExpandedInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#1D7A70","strokeWidth":"2","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"13.5","key":0}),React.createElement("path",{"strokeLinecap":"round","d":"M6.5 13.5h14","key":1})]));
}

ExpandedInline.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29"};

module.exports = ExpandedInline;

ExpandedInline.default = ExpandedInline;
